import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		windowWidth: null,
		windowHeight: null,
		menuInteractive: false, // For making menu interactable.
		pageLoaded: false, // Page load (after three menu has loaded).
		pageReady: false, // Play animation from it's start once the content behind has loaded.
		menuPosition: null, // Three menu, positioning around the profile pic.
		modalTag: null,
	},
	mutations: {
		windowSizes(state, payload) {
			state.windowWidth = payload.windowWidth;
			state.windowHeight = payload.windowHeight;
		},
		menuInteractiveStatus(state, payload) {
			if (payload.complete) {
				state.menuInteractive = true;
			} else {
				state.menuInteractive = false;
			}
		},
		pageLoaded(state, payload) {
			if (payload.complete) {
				state.pageLoaded = true;
			} else {
				state.pageLoaded = false;
			}
		},
		pageReadyStatus(state, payload) {
			if (payload.complete) {
				state.pageReady = true;
			} else {
				state.pageReady = false;
			}
		},
		menuPosition(state, payload) {
			state.menuPosition = payload.positioning;
		},
		modalContent(state, payload) {
			state.modalTag = payload.modalTag;
		},
	},
	actions: {
		windowSizes(context, payload) {
			context.commit('windowSizes', payload);
		},
		menuInteractiveStatus(context, payload) {
			context.commit('menuInteractiveStatus', payload);
		},
		pageLoaded(context, payload) {
			context.commit('pageLoaded', payload);
		},
		pageReadyStatus(context, payload) {
			context.commit('pageReadyStatus', payload);
		},
		menuPosition(context, payload) {
			context.commit('menuPosition', payload);
		},
		modalContent(context, payload) {
			context.commit('modalContent', payload);
		},
	},
});
